// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-k_gO","advertDetailHeaderLocation__value":"c-k_gP"};